import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "signup" }
const _hoisted_2 = { class: "signup-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "signup-form-wrapper"
}
const _hoisted_4 = {
  key: 1,
  class: "select-plan-wrapper"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_SignupTutorial = _resolveComponent("SignupTutorial")!
  const _component_SignupForm = _resolveComponent("SignupForm")!
  const _component_SelectPlanView = _resolveComponent("SelectPlanView")!
  const _component_CallToUpgradePopup = _resolveComponent("CallToUpgradePopup")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.loaded)
          ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.progressItem === 0 && !_ctx.isSubscriptionRestart)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_SignupTutorial, { class: "signup-tutorial" }),
            _createVNode(_component_SignupForm, {
              class: "signup-form",
              onRegistered: _cache[0] || (_cache[0] = ($event: any) => (_ctx.progressItem++))
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.progressItem === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_SelectPlanView, {
              onBackClick: _ctx.onSelectPlanViewBackClick,
              onPlanSelected: _ctx.setPlan
            }, null, 8, ["onBackClick", "onPlanSelected"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCallToUpgradePopupOpen)
        ? (_openBlock(), _createBlock(_component_CallToUpgradePopup, {
            key: 2,
            "is-premium-only": false,
            "popup-type": 'integration',
            onClose: _ctx.onCallToUpgradePopupClose
          }, null, 8, ["onClose"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_link, {
      class: "company-logo",
      to: "/"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: require('@/assets/greenspark-logo.svg'),
          alt: "GreenSpark logo",
          height: "31px",
          loading: "lazy",
          width: "160px"
        }, null, 8, _hoisted_5)
      ]),
      _: 1
    })
  ]))
}